import { styled } from 'styled-system/jsx'

const Badge = styled('div', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    fontFamily: 'body',
    fontWeight: '700',
    borderRadius: 'pill',
    paddingX: '10px',
    paddingY: '4px',
    border: '1.5px solid',
  },
  variants: {
    size: {
      sm: { fontSize: '11px', paddingX: '8px', paddingY: '3px' },
      md: { fontSize: '12px', paddingX: '10px', paddingY: '4px' },
      lg: { fontSize: '14px', paddingX: '14px', paddingY: '6px' },
    },
    tone: {
      great: {
        backgroundColor: 'quickpass.success',
        borderColor: 'quickpass.success',
        color: '#FFFFFF',
      },
      good: {
        backgroundColor: 'quickpass.primary',
        borderColor: 'quickpass.primary',
        color: '#FFFFFF',
      },
      okay: {
        backgroundColor: 'quickpass.celebration',
        borderColor: 'quickpass.celebration',
        color: '#7B5A1A',
      },
      low: {
        backgroundColor: 'transparent',
        borderColor: '#E5E0F5',
        color: 'quickpass.inkSoft',
      },
    },
  },
  defaultVariants: {
    size: 'md',
    tone: 'good',
  },
})

const ScoreNumber = styled('span', {
  base: {
    letterSpacing: '-0.2px',
  },
})

const ScoreLabel = styled('span', {
  base: {
    fontWeight: '600',
    opacity: '0.85',
  },
})

export { Badge, ScoreNumber, ScoreLabel }
